<template>
  <div class="formfield">
    <slot />
  </div>
</template>
<style lang="scss">
  .formfield {
    margin-bottom: em(20)
  }
</style>
